import {
  DRUG_CLEANSER_SEED,
  DRUG_MODEL_SEED,
  DRUG_RDM_SEED,
  DRUG_VALIDATION_SEED,
  HCP_CLEANSER_SEED,
  HCP_MODEL_SEED,
  HCP_RDM_SEED,
  HCP_VALIDATION_SEED,
} from './configurationSeeds';

const COLUMN_WIDTHS = {
  compact: 130,
  standard: 160,
};

const MODEL_COLUMNS = [
  { label: 'Label', keys: ['displayName', 'display_name', 'label'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Name', keys: ['name', 'field_name', 'key'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Type', keys: ['dataType', 'data_type', 'type'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Required', keys: ['required'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Searchable', keys: ['searchable'], align: 'left', size: COLUMN_WIDTHS.standard },
];

const MODEL_FIELDS = [
  { name: 'name', label: 'Name', required: true, helperText: 'Unique attribute name used in the model', placeholder: 'Enter Attribute' },
  { name: 'displayName', label: 'Display Name', required: true, helperText: 'Name displayed in MDM UI', placeholder: 'Name Displayed in MDM UI' },
  { name: 'description', label: 'Description', type: 'textarea', helperText: 'Optional. Descriptive information about this attribute', placeholder: 'Enter description' },
  { name: 'dataType', label: 'Data Type', type: 'select', required: true, helperText: 'Select the data type for this attribute', options: ["text", "int", "boolean", "date", "float","String"], placeholder: 'Select data type' },
  { name: 'defaultValue', label: 'Default Value', helperText: 'Optional. Default value for the attribute', placeholder: 'Enter default value' },
  { name: 'lookupType', label: 'Lookup Type', type: 'select', helperText: 'Select the lookup type you want to assign to this attribute', options: ["Active Status",
        "Countries",
        "States",
        "Specialty",
        "Professions",], placeholder: 'Select lookup type' },
  { name: 'required', label: 'Required', type: 'checkbox', helperText: 'Turn on if you require a value for this attribute' },
  { name: 'searchable', label: 'Searchable', type: 'checkbox', helperText: 'Turn on if you want to have this attribute visible by default in Advanced Search' },
];

const VALIDATION_COLUMNS = [
  { label: 'Attribute', keys: ['name'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Description', keys: ['description'], align: 'left', size: 300, minSize: 300, maxWidth: 300, wrap: true },
  { label: 'Level', keys: ['validationLevel', 'validation_level'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Type', keys: ['type'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Rule', keys: ['rule'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Last Modified Date', keys: ['lastModifiedDate', 'updated_at', 'modified_at'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Status', keys: ['active', 'status'], align: 'left', size: COLUMN_WIDTHS.standard },
];

const VALIDATION_FIELDS = [
  { name: 'name', label: 'Name', required: true, placeholder: 'Enter name' },
  { name: 'validationLevel', label: 'Validation Level', type: 'select', required: true, options: ['error', 'warning', 'info'], placeholder: 'Select validation level' },
  { name: 'type', label: 'Type', type: 'select', required: true, options: ['regex', 'exists', 'exist', 'custom'], placeholder: 'Select type' },
  { name: 'rule', label: 'Rule', type: 'textarea', placeholder: 'Enter rule' },
  { name: 'description', label: 'Description', type: 'textarea', placeholder: 'Enter description' },
  { name: 'lastModifiedDate', label: 'Last Modified', placeholder: 'Enter last modified date' },
  { name: 'active', label: 'Active', type: 'checkbox', helperText: 'Turn on if you want this validation rule to remain active' },
];

const HCP_CLEANSER_COLUMNS = [
  { label: 'Display Name', keys: ['displayName', 'name', 'cleanser_name'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Attribute', keys: ['attribute'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Cleanser Type', keys: ['cleanserType', 'type', 'category'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Cleanser', keys: ['cleanser'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Last Modified Date', keys: ['lastModifiedDate', 'updated_at', 'modified_at'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Active Status', keys: ['active', 'status'], align: 'left', size: COLUMN_WIDTHS.standard },
];

const DRUG_CLEANSER_COLUMNS = [
  { label: 'Display Name', keys: ['displayName', 'name', 'cleanser_name'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Attribute', keys: ['attribute'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Cleanser Type', keys: ['cleanserType', 'type', 'category'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Cleanser', keys: ['cleanser'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'URL', keys: ['url'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Last Modified Date', keys: ['lastModifiedDate', 'updated_at', 'modified_at'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Active Status', keys: ['active', 'status'], align: 'left', size: COLUMN_WIDTHS.standard },
];

const HCP_CLEANSER_FIELDS = [
  { name: 'displayName', label: 'Display Name', required: true, placeholder: 'Enter display name' },
  { name: 'attribute', label: 'Attribute', required: true, placeholder: 'Enter attribute' },
  { name: 'cleanserType', label: 'Cleanser Type', placeholder: 'Enter cleanser type' },
  { name: 'cleanser', label: 'Cleanser', placeholder: 'Enter cleanser' },
  { name: 'lastModifiedDate', label: 'Last Modified', placeholder: 'Enter last modified date' },
  { name: 'active', label: 'Active', type: 'checkbox', helperText: 'Turn on if you want this cleanser active' },
];

const DRUG_CLEANSER_FIELDS = [
  { name: 'displayName', label: 'Display Name', required: true, placeholder: 'Enter display name' },
  { name: 'attribute', label: 'Attribute', required: true, placeholder: 'Enter attribute' },
  { name: 'cleanserType', label: 'Cleanser Type', placeholder: 'Enter cleanser type' },
  { name: 'cleanser', label: 'Cleanser', placeholder: 'Enter cleanser' },
  { name: 'url', label: 'URL', placeholder: 'Enter URL' },
  { name: 'lastModifiedDate', label: 'Last Modified', placeholder: 'Enter last modified date' },
  { name: 'active', label: 'Active', type: 'checkbox', helperText: 'Turn on if you want this cleanser active' },
];

const RDM_COLUMNS = [
  { label: 'Name', keys: ['name', 'dataset_name'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Start date', keys: ['startdate', 'startDate'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'End date', keys: ['enddate', 'endDate'], align: 'left', size: COLUMN_WIDTHS.standard },
  { label: 'Source values', keys: ['sourcevalues', 'sourceValues'], align: 'left', size: COLUMN_WIDTHS.standard },
];

const RDM_FIELDS = [
  { name: 'name', label: 'Lookup Name', required: true, placeholder: 'Enter lookup name' },
  { name: 'startdate', label: 'Start Date', placeholder: 'Enter start date' },
  { name: 'enddate', label: 'End Date', placeholder: 'Enter end date' },
  { name: 'sourcevalues', label: 'Source Values', type: 'number', placeholder: 'Enter source values' },
  { name: 'unmappedvalues', label: 'Unmapped Values', type: 'number', placeholder: 'Enter unmapped values' },
];

const CRUD_DEFINITIONS = {
  hcp: {
    model: {
      title: 'Attributes',
      subtitle: 'HCP schema/model attributes',
      storageKey: 'itemDataModeler',
      storageVersion: 'hcp-model-v3',
      seedRows: HCP_MODEL_SEED,
      columns: MODEL_COLUMNS,
      fields: MODEL_FIELDS,
      addButtonLabel: 'Attribute',
    },
    'validation-rules': {
      title: 'Validation Rules',
      subtitle: 'HCP validation rule configuration',
      storageKey: 'itemValidateFunction',
      storageVersion: 'hcp-validation-v2',
      seedRows: HCP_VALIDATION_SEED,
      columns: VALIDATION_COLUMNS,
      fields: VALIDATION_FIELDS,
      addButtonLabel: 'Validation Rule',
    },
    cleansers: {
      title: 'Cleansers',
      subtitle: 'Configured HCP data cleanser functions',
      storageKey: 'itemCleanserFunction',
      storageVersion: 'hcp-cleansers-v2',
      seedRows: HCP_CLEANSER_SEED,
      columns: HCP_CLEANSER_COLUMNS,
      fields: HCP_CLEANSER_FIELDS,
      getRowKey: (row) => row.displayName || row.attribute,
      addButtonLabel: 'Cleanser',
    },
    'reference-datasets': {
      title: 'Lookup Types',
      subtitle: 'HCP reference dataset definitions',
      storageKey: 'itemrdm',
      storageVersion: 'hcp-rdm-v2',
      seedRows: HCP_RDM_SEED,
      columns: RDM_COLUMNS,
      fields: RDM_FIELDS,
      addButtonLabel: 'Lookup Type',
    },
  },
  drug: {
    model: {
      title: 'Attributes',
      subtitle: 'Drug/product schema/model attributes',
      storageKey: 'drugItemDataModeler',
      storageVersion: 'drug-model-v3',
      seedRows: DRUG_MODEL_SEED,
      columns: MODEL_COLUMNS,
      fields: MODEL_FIELDS,
      addButtonLabel: 'Attribute',
    },
    'validation-rules': {
      title: 'Validation Rules',
      subtitle: 'DRUG validation rule configuration',
      storageKey: 'drugItemValidateFunction',
      storageVersion: 'drug-validation-v2',
      seedRows: DRUG_VALIDATION_SEED,
      columns: VALIDATION_COLUMNS,
      fields: VALIDATION_FIELDS,
      addButtonLabel: 'Validation Rule',
    },
    cleansers: {
      title: 'Cleansers',
      subtitle: 'Configured drug/product cleanser functions',
      storageKey: 'drugItemCleanserFunction',
      storageVersion: 'drug-cleansers-v2',
      seedRows: DRUG_CLEANSER_SEED,
      columns: DRUG_CLEANSER_COLUMNS,
      fields: DRUG_CLEANSER_FIELDS,
      getRowKey: (row) => row.displayName || row.attribute,
      addButtonLabel: 'Cleanser',
    },
    'reference-datasets': {
      title: 'Lookup Types',
      subtitle: 'Drug/product reference dataset definitions',
      storageKey: 'drugitemrdm',
      storageVersion: 'drug-rdm-v3',
      seedRows: DRUG_RDM_SEED,
      columns: RDM_COLUMNS,
      fields: RDM_FIELDS,
      addButtonLabel: 'Lookup Type',
    },
  },
};

export const getConfigCrudDefinition = (entityType, section) => CRUD_DEFINITIONS[entityType]?.[section] || null;
